module.exports = __webpack_public_path__ + "img/101.6d39fe4f.jpg";